import { createSlice } from '@reduxjs/toolkit';
import { PATHS } from '@/config/estepperConfig';

const initial = {
  ...PATHS,
};

const slice = createSlice({
  name: 'paths',
  initialState: initial,
  reducers: {
    setPaths: (state, { payload }) => ({ ...payload }),
    changeStepAvailability: (state, { payload }) => ({
      ...payload,
    }),
    restore: () => initial,
  },
});

export const { setPaths, changeStepAvailability, restore } = slice.actions;

export default slice.reducer;
